var map = {
	"./cdn/CDN-Header.svg": 1215,
	"./cdn/Feature-1.svg": 1297,
	"./cdn/Feature-2.svg": 1298,
	"./cdn/Feature-3.svg": 1299,
	"./cdn/Feature-4.svg": 1300,
	"./cdn/Feature-5.svg": 1301,
	"./cdn/Feature-6.svg": 1302,
	"./cdn/Feature-7.svg": 1303,
	"./cdn/Feature-8.svg": 1304,
	"./cdn/IranMap.svg": 1137,
	"./cdn/Malwares_Attackers.svg": 1305,
	"./cdn/access.svg": 1306,
	"./cdn/atactks.svg": 1307,
	"./cdn/cms.svg": 1308,
	"./cdn/company-c.svg": 1309,
	"./cdn/company.svg": 1310,
	"./cdn/customer.svg": 1311,
	"./cdn/ddos-c.svg": 1312,
	"./cdn/ddos-d.svg": 1313,
	"./cdn/ddos.svg": 1314,
	"./cdn/ddosAtacks.svg": 1315,
	"./cdn/domain-c.svg": 1316,
	"./cdn/domain-d.svg": 1317,
	"./cdn/domain.svg": 1318,
	"./cdn/domainss.svg": 1319,
	"./cdn/earth.svg": 1145,
	"./cdn/geography.svg": 1320,
	"./cdn/no.svg": 871,
	"./cdn/price.svg": 1321,
	"./cdn/report-c.svg": 1322,
	"./cdn/report-d.svg": 1323,
	"./cdn/report.svg": 1324,
	"./cdn/scrubbing.svg": 1149,
	"./cdn/seo.svg": 1325,
	"./cdn/speed.svg": 1326,
	"./cdn/ssl.svg": 1327,
	"./cdn/startup-c.svg": 1328,
	"./cdn/startup.svg": 1329,
	"./cdn/store-c.svg": 1330,
	"./cdn/store.svg": 1331,
	"./cdn/tick.svg": 1332,
	"./cdn/uptime.svg": 1333,
	"./cdn/waf-c.svg": 1334,
	"./cdn/waf-d.svg": 1335,
	"./cdn/waf.svg": 1336,
	"./cdn/yes.svg": 872,
	"./cdn/zarb.svg": 1337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1927;